
import { getImage } from "@/service/image.service";
import { Image } from "@/types/Image.type";
import { defineComponent, PropType, ref } from "@vue/runtime-core";

interface ImageData extends Image {
  title?: string;
}

export default defineComponent({
  components: {},
  props: {
    thumbnail: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array as PropType<ImageData[]>,
      required: true,
    },
    modal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      src: ref<{ [name: string]: string }>({}),
    };
  },
  created() {
    this.loadImage();
  },
  unmounted() {
    // - free memory
    Object.values(this.src).forEach((value) => URL.revokeObjectURL(value));
  },
  methods: {
    formatDate(datetime: Date) {
      let dateTime = undefined;
      if (datetime !== null) {
        const dateString: Date = new Date(`${datetime}`);

        dateTime = this.$d(new Date(dateString), "dateTime");
      }
      return dateTime !== undefined ? dateTime : "-";
    },
    loadImage() {
      this.images.forEach((image) => {
        if (!image?.fileName || this.src[image.fileName]) return;
        getImage(image.fileName, this.thumbnail)
          .then((res) => {
            if (!image?.fileName) return;
            this.src[image.fileName] = res;
          })
          .catch(void 0);
      });
    },
    checkTime(interval: number, dateTime: Date) {
      if (interval !== null && dateTime !== null) {
        // Variables asignadas para calcuar la diferencia de tiempo
        let lastTime = undefined;
        let nowTime = undefined;
        let timeDiference = undefined;

        // Variables para tener en cuenta los tiempos
        let warning = 2;
        let danger = 3;

        // Calculamos la diferencia de tiempo
        const dateString: Date = new Date(`${dateTime}`);
        lastTime = dateString.getTime();
        nowTime = new Date().getTime();
        timeDiference = Math.floor((nowTime - lastTime) / 1000 / 60);

        // Comprobacion de los intervalos si es menor de 15 minutos se reasigna las alertar warning y danger
        if (interval < 15) {
          warning = 26;
          danger = 60;
          interval = 1;
        }

        // Comprobamos si la diferencia del tiempo pasa del tiempo establecido para el aviso
        if (timeDiference < interval * danger && timeDiference >= interval * warning) {
          return "warning";
        } else if (timeDiference >= interval * danger) {
          return "danger";
        }
      }
    },
  },
  watch: {
    images: {
      handler() {
        this.loadImage();
      },
      deep: false,
    },
  },
});
